import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
import { ThemeProvider } from "styled-components";
import configureStore from "./store";
import App from "./layout/App";
import { theme } from "./theme/theme";
import "./i18n";
import "react-lazy-load-image-component/src/effects/blur.css";
import "mapbox-gl/dist/mapbox-gl.css";

const { store, persistor } = configureStore();

const queryClient = new QueryClient();

const Main = () => (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <App />
        </ThemeProvider>
      </QueryClientProvider>
    </PersistGate>
  </Provider>
);

export default Main;
